import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { getJddAddress } from '../services/Kyc'
import { jddAddressActions } from '../store/slices/JddAddress'
import { handleError } from '../services/utils'

const JddAddressHook = (
  isJddDocUploaded: boolean,
  isUploadDocDisplayed: boolean
) => {
  const history = useHistory()
  const dispatch = useDispatch()
  useEffect(() => {
    async function getAddress() {
      dispatch(jddAddressActions.addressLoading())
      try {
        const response = await getJddAddress()
        // @ts-ignore
        dispatch(jddAddressActions.addressReceived(response))
      } catch (e) {
        dispatch(jddAddressActions.addressFailed())
        handleError(e, history)
      }
    }

    if (isJddDocUploaded && isUploadDocDisplayed) {
      getAddress()
    }
    // eslint-disable-next-line
  }, [dispatch, isJddDocUploaded, isUploadDocDisplayed])
}

export default JddAddressHook
